import { type RatingDistributionLayoutOptions } from '@/domain/reporting/reporting-shared.types';

export const REPORTING_RATING_AXIS_MIN = 0;
export const REPORTING_RATING_AXIS_MAX = 5;

export const REPORTING_RATING_DISTRIBUTION_LAYOUT: RatingDistributionLayoutOptions = {
    width: 360,
    rowHeight: 16,
    rowGap: 6,
    topPadding: 6,
    bottomPadding: 6,
    leftLabelWidth: 56,
    rightLabelWidth: 58,
    gap: 8,
};
